// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"2441":"bd6d3dc836e836cd4795","5775":"bdb5a44b157eaff757ea","5862":"18c97d281a8207f0ce8d"}[chunkId] + "";
};